export const en = {
    new_application: 'New application',
};
